import { Component } from '@angular/core';

@Component({
  selector: 'app-accessibility-statement-policy',
  templateUrl: './accessibility-statement.component.html',
  styleUrls: ['./accessibility-statement.component.scss']
})
export class AccessibilityStatementComponent {
}
